import { BaseCard } from '@/shared/components'
import { DealIcon } from '@/shared/components/icons/DealIcon'
import { IdLayout } from '@/shared/components/IdLayout/IdLayout'
import { ItemLayout } from '@/shared/components/ItemLayout/ItemLayout'
import { formatDate } from '@/shared/lib/date'
import { MessageModel } from '../../types/MessageTypes'
import { MessageStatus } from '../MessageStatus/MessageStatus'

type MessageProps = {
  message: MessageModel
}

export const MobileBlockMessage = ({ message }: MessageProps) => {
  return (
    <BaseCard className="px-5 text-sm md:hidden mb-4 last:mb-0">
      <div className="flex justify-between mb-4">
        <span className="text-text-secondary">{formatDate(message.createdAt)}</span>
        <MessageStatus status="recognized" />
      </div>
      <div className="mb-[30px]">
        <span className="font-klein font-medium inline-block mb-2">
          От: <span>900</span>
        </span>
        <p className="text-text-secondary">{message.message}</p>
      </div>
      <div>
        <span className="text-text-secondary inline-block mb-2">Сделка:</span>
        <div className="flex justify-between mb-6">
          <ItemLayout icon={<DealIcon status="green" />} title="dd" subtitle="dd" />
          <IdLayout id="44" />
        </div>
        <span className="text-text-secondary inline-block mb-2">Сумма сделки:</span>
        <div className="flex justify-between">
          <span className="text-lg font-klein font-medium">5.03 USDT</span>
          <span className="text-text-secondary">500 RUB</span>
        </div>
      </div>
    </BaseCard>
  )
}
